module.exports = __webpack_public_path__ + "img/20.d5e2ab8e.png";